(() => {
  const selector = '#snize-instant-search-results.snize-ac-results-mobile';
  let frame = 0;
  let gesture = null;

  function syncViewport() {
    frame = 0;
    const panel = document.querySelector(selector);
    if (!panel) return;
    const viewport = window.visualViewport;
    if (viewport && Math.abs(viewport.scale - 1) > 0.05) return;
    panel.setAttribute('data-lk-mobile-search', '');
    panel.style.setProperty('--lk-search-height', Math.round(viewport ? viewport.height : window.innerHeight) + 'px');
    panel.style.setProperty('--lk-search-top', Math.round(viewport ? viewport.offsetTop : 0) + 'px');
    const input = panel.querySelector('#snize-mobile-search-input');
    if (input) input.setAttribute('enterkeyhint', 'search');
  }

  function scheduleViewport() {
    if (!frame) frame = window.requestAnimationFrame(syncViewport);
  }

  function browsingInput(target) {
    const input = document.activeElement;
    if (!(target instanceof Element) || !input || input.id !== 'snize-mobile-search-input') return null;
    const panel = input.closest(selector);
    if (!panel || !panel.contains(target) || target.closest('.snize-mobile-top-panel')) return null;
    return input;
  }

  document.addEventListener('focusin', event => {
    if (event.target instanceof Element && event.target.id === 'snize-mobile-search-input') scheduleViewport();
  });

  document.addEventListener('touchstart', event => {
    gesture = null;
    const input = browsingInput(event.target);
    if (!input || event.touches.length !== 1) return;
    gesture = { input, x: event.touches[0].clientX, y: event.touches[0].clientY };
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', event => {
    if (!gesture || event.touches.length !== 1) return;
    const dx = Math.abs(event.touches[0].clientX - gesture.x);
    const dy = Math.abs(event.touches[0].clientY - gesture.y);
    if (dy < 12 || dy <= dx) return;
    if (document.activeElement === gesture.input) gesture.input.blur();
    gesture = null;
    scheduleViewport();
  }, { passive: true, capture: true });

  function clearGesture() {
    gesture = null;
  }

  document.addEventListener('touchend', clearGesture, { passive: true, capture: true });
  document.addEventListener('touchcancel', clearGesture, { passive: true, capture: true });
  document.addEventListener('wheel', event => {
    if (event.ctrlKey || !event.deltaY) return;
    const input = browsingInput(event.target);
    if (input) input.blur();
  }, { passive: true, capture: true });

  window.addEventListener('resize', scheduleViewport, { passive: true });
  window.addEventListener('pageshow', scheduleViewport);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleViewport, { passive: true });
    window.visualViewport.addEventListener('scroll', scheduleViewport, { passive: true });
  }
  scheduleViewport();
})();
